import React from "react";

const SVG = ({
  style = {},
  fill = "#1D1D1B",
  width = "100%",
  className = "",
  viewBox = "0 0 600 600"
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d="M562.4,526.9c-13.1-12.9-25.5-26.5-38.3-39.7c-3.1-3.2-4.1-5.5-3.4-11c1.7-14.7,3.8-29.7-2.4-44.5
        c-6.7-15.9-19.4-26-30.7-37.5c-28.8-29.3-57.8-58.4-86.9-87.5c-4-4-5.9-6.7-0.6-11.9c10.9-10.7,20.7-22.8,31.4-33.8
        c14.2-14.6,14.6-14.6-0.4-29c-4.8-4.6-4.8-7.8-0.2-12.3c4.6-4.5,8.6-9.6,13.1-14.8c-3.7-4.4-6.5-8.1-9.7-11.4
        c-4.2-4.3-5-7.9-0.2-12.6c7.7-7.7,14.4-16.3,22.1-23.9c4.4-4.4,10.1-7.3,3.5-14.4c-0.7-0.7,0.5-4.4,1.8-5.8
        c14.9-16.2,29.8-32.4,45-48.2c16.8-17.6,34.2-34.6,50.8-52.3c2.1-2.3,3.2-8.2,1.9-10.8c-2.4-4.5-6.8-6.9-11.6-1.1
        c-3.1,3.7-7.6,6.2-11,9.7c-30.1,31.1-60.1,62.2-90.8,94c-5.7-7.4-9.7-4.4-13.9,0.4c-9.4,10.9-19,21.6-28.5,32.4
        c-4.4-4.2-6.6-6.3-8.7-8.3c-11.1-10.7-11.1-10.7-22.1,0.2c-9.1,9.1-10.3,9.1-19.4,0.2c-1.4-1.4-2.6-2.9-4-4.2
        c-10-9.7-10.3-10-19.6,0c-13.5,14.4-26.5,29.3-39.9,44.2c-4.4-4.2-6.5-6.1-8.5-8.1c-29.7-29.6-59.2-59.3-89.1-88.7
        c-12.1-11.8-23.5-25.2-37.6-33.7c-18.9-11.4-51.8-8.2-74.5,13.1C54.5,99.3,46.7,150,76.5,178c35.9,33.8,69.3,70.4,104.3,105.3
        c6.9,6.8,8.2,10.8,1.1,18c-25,25-49.5,50.6-74.3,75.8c-13.4,13.7-13.5,13.6-28,0.6c-0.2-0.2-0.7-0.2-0.9-0.4
        c-3.2-4.3-5.7-4.5-10.1-0.4c-15.8,14.5-16.1,16.3-1.2,30.8c1.2,1.1,2.8,1.9,3.9,3c8.7,9.3,17.3,18.6,27.3,29.4
        c-11.8,11.5-22.5,21.8-33.1,32.3c-4.1,4.1-7.6,4.2-11.6,0c-4.4-4.7-9.1-9.2-13.5-13.9c-4.1-4.3-7.4-6.5-12.6-0.7
        c-4.8,5.3-7.5,8.8-1.1,15.3c31.5,31.6,62.8,63.6,93.8,95.8c5,5.1,7.4,5.5,12.5,0.1c5.5-5.8,5.6-9.4-0.3-14.4
        c-3.9-3.3-7-7.5-10.4-11.4c-3.6-4.2-4.8-7.6,0.3-12.5c9.2-8.7,17.6-18.5,26.2-27.8c4.1-4.4,7.2-4.9,11.9,0.2
        c10.8,11.7,22.4,22.8,33.8,33.9c1.8,1.7,5.9,3.9,6.7,3.2c6.4-5.7,12.3-12,18.5-18.4c-4.9-4.8-8.5-8.5-12.3-12
        c-5.9-5.5-6.6-10.2-0.3-16.4c15.2-15.1,29.7-31,44.6-46.4c14.6-15.1,29.5-29.9,44.6-45.2c5.9,5.4,11.1,9.9,16,14.7
        c31.7,32,63.3,64.1,95,96.2c17.1,17.3,37.1,23,60.4,15.6c8.5-2.7,15.8-1.9,22.7,6.1c10.4,12,22.3,22.7,34,33.5
        c13.3,12.3,28.7,12.2,39.7,0.1C575.8,555.4,576.6,541,562.4,526.9z M212,253.5c-0.1-1.1-0.2-2.2-0.3-3.4
        c8.6-9.4,17.1-18.7,26.7-29.2c-4.5-4.7-8.7-9.1-13.9-14.4c-9.2,10.6-17.4,20.1-25.5,29.3c-10.5-8-10.7-9.4-3.3-17.5
        c6.1-6.7,12.1-13.4,18.4-20.2c-1.7-2.3-3.2-4.4-4.8-6.3c-5.9-6.9-11.5-6.8-17.4,0.3c-5.5,6.6-11.6,12.8-17.4,19.2
        c-9.1-4.3-8.5-9.4-2.3-15.7c6.6-6.6,12.9-13.6,20.5-21.7c-3.3-2.7-6.2-4.3-8.2-6.8c-5-6.3-9.3-5.5-14.2,0.2
        c-6.1,7.1-12.6,13.9-18.8,20.6c-8.3-4.7-9.8-9.2-3.3-15.1c6.8-6.2,13.4-12.7,21.6-20.6c-6.1-5.4-10.8-9.6-16.5-14.7
        c-6.8,7.2-13.1,14.7-20.3,21.2c-2.3,2.1-6.7,1.6-10.1,2.3c0.3-3.4-0.6-7.7,1.1-9.9c6.1-7.9,13-15,22.1-25.2
        c-13.2-11.8-26.6-23.7-40.5-36.1c19.5-12.3,35.4-9.9,50.2,5.3c34.7,35.5,69.3,71,104.2,106.2c6.4,6.4,8.9,10.8,0.4,18.1
        c-12.7,10.9-23.8,23.7-36.4,34.8C221.9,256.2,216.2,253.9,212,253.5z M298.8,358.1c-21-22.2-41.4-43.5-61.3-65.1
        c-1.4-1.5-1.4-6.9,0-8.4c32.1-33.7,64.4-67.1,96.7-100.5c3.6-3.7,6.9-3.4,10.5,0.4c18.3,19,36.8,37.9,55.3,56.8
        c4,4.1,5.2,7.2,0.3,12.2C366.9,287.6,333.7,322.1,298.8,358.1z M492.6,475c-1.4-0.4-3.1-0.4-4.4-1.2c-3.4-2.1-7.6-7.2-9.6-6.4
        c-4.4,1.8-7.7,6.5-11.4,10.1c-3.7,3.6-7,7.8-11.2,10.7c-2.1,1.5-5.8,0.5-8.7,0.7c0.2-3.2-0.8-7.5,0.9-9.4
        c6.8-8,14.5-15.2,22.7-23.6c-4.5-4.5-8.9-8.9-16-15.9c-6.7,8-12.7,16.1-19.6,23.2c-2.2,2.3-7,1.9-10.6,2.8c0.5-3.7-0.1-8.4,1.8-11
        c6.1-7.9,13.1-14.9,20-22.5c-4.5-5-8.6-9.4-14-15.2c-4.4,5-8.6,10.1-13.1,14.8c-4.4,4.6-9.1,9-13.7,13.5c-9.3-4.8-7-10.3-0.7-16.2
        c6.1-5.8,12-11.9,18.8-18.6c-2.7-3.4-4.9-6.1-7-8.8c-5.2-6.5-9.8-5.5-15.1,0.3c-6.1,6.7-12.9,12.7-19.5,19.1
        c-8.3-6.4-8.4-7.6-0.6-15.6c4.7-4.8,9.1-10.1,14.2-14.4c5.5-4.7,3.8-8-0.7-11.8c-4.3-3.6-7.6-10.5-14.1-2.8
        c-4.9,5.7-10.1,11.1-15.1,16.7c-3.4,3.8-6.5,6.5-11.1,1.2c-4.1-4.7-1.7-7.2,1.8-10.5c4.6-4.4,8.5-9.6,13-14.2
        c8.3-8.7,8.2-10.3-1.7-17.2c-1.6-1.1-3.1-2.3-6.3-4.6c-6.8,7.5-13,14.8-19.8,21.5c-2,2-5.8,2-8.7,2.9c0.6-3.5,0-8.1,2-10.2
        c11.4-12.5,23.7-24.2,35-36.8c5.6-6.2,9-4.5,13.8,0.4c32.6,33.4,65.1,66.9,98.2,99.7C495.7,439.5,503.3,456.1,492.6,475z"
    />
  </svg>
);

export default SVG;